import React, { useEffect, useState } from "react";
import { UserContext } from "../App";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

const Goals = () => {
  const { user, setUser, goalrepeticion, setGoalrepeticion } =
    useContext(UserContext);
  const [todayGoalReached, setTodayGoalReached] = useState(false);
  const navigate = useNavigate();

  const calculateCaloriesBurned = () => {
    const menRMP =
      88.362 + 13.397 * user.weight + 4.799 * user.height - 5.677 * user.age;
    const womenRMP =
      447.593 + 9.247 * user.weight + 3.908 * 4 - 4.33 * user.age;
    let BaseCaloryBurn;
    if (user.gender === "male") {
      BaseCaloryBurn = 0.1 * menRMP;
    } else {
      BaseCaloryBurn = 0.1 * womenRMP;
    }

    const dailyCaloryDeficit = ((user.goal - user.weight) / 30) * 7700;
    const repetitionofsetofbicepcurlsrequired =
      dailyCaloryDeficit / BaseCaloryBurn;
    // console.log(repetitionofsetofbicepcurlsrequired);
    if (repetitionofsetofbicepcurlsrequired < 0) {
      setGoalrepeticion(Math.round(-1 * repetitionofsetofbicepcurlsrequired));
    } else {
      setGoalrepeticion(Math.round(repetitionofsetofbicepcurlsrequired));
    }
    // setGoalrepeticion(repetitionofsetofbicepcurlsrequired);
    // console.log(caloriesBurned);
  };

  useEffect(() => {
    const earlierTime = localStorage.getItem("current_time_completed");
    const difference = Math.abs(new Date() - earlierTime);
    if (difference < 86400000) {
      setTodayGoalReached(true);
    }
  }, []);

  useEffect(() => {
    if (user) {
      calculateCaloriesBurned();
    }
  }, [user]);

  return (
    <section className="relative">
      <div className="max-w-6xl px-4 mx-auto sm:px-6">
        <div className="pt-10 pb-12 md:pt-10 md:pb-20">
          <div className="gap-4 pb-12 text-center md:pb-16">
            <h1 className="mb-4 text-5xl font-extrabold tracking-tighter md:text-6xl leading-tighter">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">
                Goals
              </span>
            </h1>
            <div className="text-3xl">
              You started with <b>{user.weight}</b> lbs and your goal is{" "}
              <b>{user.goal}</b> lbs.
            </div>
            <p className="text-2xl">
              You're {30 - user.streak} days away from your goal ‎️‍🔥.
            </p>
            <button
              disabled={todayGoalReached}
              onClick={() => navigate("/exercisetracker")}
              className="mt-10 bg-gray-200 rounded-md w-36 p-1 m-auto border-[1px] border-gray-500"
            >
              Let's get started!
            </button>
            {todayGoalReached ? (
              <p>You've already completed your goal for today!</p>
            ) : (
              <p>
                You have {goalrepeticion} repetitions of bicep curls to do
                today!
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Goals;
